// @vitejs/plugin-react
import { Routes } from 'react-router-dom';
import { AppRoutes } from './RoutesConfig';
import { routes } from './routes';

const URLs = () => (
  <Routes>
    {AppRoutes()}
  </Routes>
);

// Reverse lookup function
export const reverse = (name) => {
  const route = routes.find(route => route.name === name);
  return route ? route.url : '#';
};

export default URLs;